<div *ngIf="board.sprintReleased" class="sprint_released">
    <div class="ico_done"></div>
    <div class="sprint_released_text">
        Sprint
        <span class="medium">“<span class="sprint_released_title">{{board?.name}}</span>”</span> is released.
    </div>
</div>
<column-list *ngIf="!board.sprintReleased" [boardId]="board.id" [boardType]="board.type"></column-list>
